module.exports = __webpack_public_path__ + "img/header/rep-watermark.png";